import { FC } from "react";
import { StatusBadge } from "@/components/ui/status-badge";
import Text from "@/components/ui/text";
import { Bullet, BulletDashed } from "@dreamhub/designsystem/icons";
import { ContractTableStatus } from "@/pages/contracts/types";
import {
  contractTableStatusColors,
  getContractStatusLabel
} from "@/pages/contracts/helpers";

export const getContractStatusIcon = (status: ContractTableStatus) =>
  status === ContractTableStatus.UPCOMING ? <BulletDashed /> : <Bullet />;

interface Props {
  status: ContractTableStatus;
  displayFallback?: string | null;
  isTable?: boolean;
  className?: string;
}

const ContractStatusBadge: FC<Props> = ({
  status,
  displayFallback,
  isTable,
  className
}) => {
  const label = getContractStatusLabel(status, displayFallback);

  if (
    status === ContractTableStatus.NO_SERVICES ||
    status === ContractTableStatus.ONE_TIME
  ) {
    return <Text variant="smBodyTertiary">{label}</Text>;
  }

  return (
    <StatusBadge
      statusColor={contractTableStatusColors[status]}
      isTable={isTable}
      className={className}
      icon={getContractStatusIcon(status)}
    >
      {label}
    </StatusBadge>
  );
};

export default ContractStatusBadge;
